/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook usePostCoverage
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for post coverage
 *
 */
interface IProps {
	patientId: string;
	coveragePostModel: Insurance.CoveragePostModel;
}
const usePostCoverage = (): UseMutationResult<string, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ patientId, coveragePostModel }) => {
			const { data } = await api.FHIRCoverageApi.postCoverage({ patientId, coveragePostModel });
			return data?.coverageId;
		},
		onSuccess: () => {
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.insurances] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default usePostCoverage;
